import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";

import MaterialTable from "material-table";
import Sidebar from '../../../../Template/Sidebar/Sidebar';
import Header from '../../../../Template/Header/Header';
import {baseUrl} from '../../../../../config';
import DatePicker from "react-datepicker";
import moment from 'moment'
import CloseIcon from '@mui/icons-material/Close';
import "react-datepicker/dist/react-datepicker.css";

import {clickColor,inArray} from './../../../../../library/util';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loader from 'react-loader-spinner';

import Typography from "@material-ui/core/Typography";
import './../../css/profit.css';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import axiosIntance from '../../../../../helper/axios';



function ByParentSKU() {
    const history = useHistory();
    const [selectedRow, setSelectedRow] = useState(null);
    const ReportTile='Profits Diagnosis - Full View - By Parent SKU';
    const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    const [endDate, setEndDate] = useState(new Date(Date.now()).setHours(23,59,0,0));
    const [productCategory,setProductCategory]=useState('');
    const [productCategoryArray,setProductCategoryArray] = useState([]);
    const [AFFID,setAFFID]=useState('');
    const [AFFIDArray,setAFFIDArray]=useState([]);
    const [C1,setC1]=useState('');
    const [C1Array,setC1Array]=useState([]);
    const [group,setgroup]=useState('');
    const [groupArray,setgroupArray]=useState([]);
    const [REFCB,setREFCB]=useState(false);
    const [Refund,setRefund]=useState('');
    const [CB,setCB]=useState('');
    
    const handleSignOut = () => {
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }

      checkUserTypeFn(history);

      function checkUserTypeFn(history){
        const userdata=JSON.parse(localStorage.getItem('userdata'));
        const usertype=userdata.type;
        console.log('in check usertype fn');
        console.log(usertype)
      //   if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='user'){
      //     history.push('/');
      //  }
      if(usertype!='owneradmin' && usertype!='superadmin'){
        history.push('/');
      }
      }
      const [selectedrowList,setSelectedRowList]=useState([]);


      const setRowBackground = (selectedRow)=>{
             if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
             setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
             setSelectedRow(selectedRow.tableData.id)
             console.log(selectedrowList)
             }else{    
               setSelectedRow(500000)
               setSelectedRowList([])
             }
           }
   
    // if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
    //   history.push('/');
    // }
  
    const [reportData,setReportData]=useState([])
    const [loader,setLoader]=useState(false)
    axiosIntance.defaults.timeout = 36000000;//10min
    const [message, setMessage] = useState('')
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];
    const [successMsg,setSuccessMsg]=useState('')
    useEffect(() => {
      //fetchApi();
      return () => {
        console.log('un subscribe')
      }
  
  
  
    }, [])
    
    // const ResetFilter = () => {
    //   setMessage('')
    //   setEndDate(new Date(Date.now()))
    //   setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    // }
    const ResetFilter = () => {
      setMessage('')
      setEndDate(new Date(Date.now()))
      setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
      
      setReportData([]);
    }

    
   
  const fetchApi = () =>{
    console.log('here check')
    console.log(startDate)
    if(startDate==null){
      setMessage('Start Date must not be blank')
      return false;
    }if(endDate==null){
      setMessage('End Date must not be blank')
      return false;
    }else{
      setMessage('')
    }
    setLoader(true)
    let groupStr=groupArray.join(',');
    console.log(groupStr);
    var response={};
    response.data={};
    response.data.result=[];
    setLoader(true);
    axiosIntance.get(baseUrl+'/reports/profitabilityDiagnosis/fullview?startdate='+moment(startDate).format('YYYY-MM-DD HH:mm')+"&enddate="+moment(endDate).format('YYYY-MM-DD HH:mm')+"&type=parent_sku&group="+groupStr, {}).then(response => {
  
        if (response.data.result.length > 0) {
          console.log('data we have')
          response.data.result.forEach((i,j)=>{
            console.log(i);
            i.revenue="$"+i.revenue.toLocaleString();
            i.revenue_per_fe="$"+i.revenue_per_fe.toLocaleString();
            i.revenue_per_order="$"+i.revenue_per_order.toLocaleString();
            i.total_cpa_cost="$"+i.total_cpa_cost.toLocaleString();
            i.cogs="$"+i.cogs.toLocaleString();
            i.processing_cost="$"+i.processing_cost.toLocaleString();
            i.reserve_cost="$"+i.reserve_cost.toLocaleString();
            i.processing_plus_reserves="$"+i.processing_plus_reserves.toLocaleString();
            i.total_shipping_cost="$"+i.total_shipping_cost.toLocaleString();
            i.total_handling_cost="$"+i.total_handling_cost.toLocaleString();
            i.cost_of_cs="$"+i.cost_of_cs.toLocaleString();
            i.total_transactions_cost="$"+i.total_transactions_cost.toLocaleString();
            i.void_dollar_amount="$"+i.void_dollar_amount.toLocaleString();
            i.refund_dollar_amount="$"+i.refund_dollar_amount.toLocaleString();
            i.chargeback_dollar_amount="$"+i.chargeback_dollar_amount.toLocaleString();
            i.cashflow="$"+i.cashflow.toLocaleString();
            i.net_profit="$"+i.net_profit.toLocaleString();

            i.CPA="$"+i.CPA.toLocaleString();
            i.cogs_per_fe="$"+i.cogs_per_fe.toLocaleString();
            i.ship_cost_per_fe="$"+i.ship_cost_per_fe.toLocaleString();
            i.handling_cost_per_fe="$"+i.handling_cost_per_fe.toLocaleString();
            i.cost_of_cs_per_fe="$"+i.cost_of_cs_per_fe.toLocaleString();
            i.transactions_cost_per_fee="$"+i.transactions_cost_per_fee.toLocaleString();

            i.net_profit_per_fe="$"+i.net_profit_per_fe.toLocaleString();
            i.net_profit_per_order="$"+i.net_profit_per_order.toLocaleString();
          

            i.chargeback_dollar_percent=roundToTwo(i.chargeback_dollar_percent*100)+"%";

            i.chargeback_rate_percent=roundToTwo(i.chargeback_rate_percent*100)+"%";

            i.refund_dollar_percent=roundToTwo(i.refund_dollar_percent*100)+"%";

            i.refund_rate_percent=roundToTwo(i.refund_rate_percent*100)+"%";

            i.void_rate_percent=roundToTwo(i.void_rate_percent*100)+"%";

            i.void_dollar_percent=roundToTwo(i.void_dollar_percent*100)+"%";

            i.click_bump_rate=roundToTwo(i.click_bump_rate*100)+"%";
          });
          setReportData(response.data.result);
          console.log(response.data.result)
          setLoader(false)
          //setSuccessMsg('Data')
        } else {
          setLoader(false)
          setReportData([]);
          //setMessage('No data');
          console.log(45)
         // history.push('/home');
        }
  
      }).catch(error => {
        setLoader(false)
        setMessage('Something went wrong');
      });
  }

  const fetchApiDownload = () =>{

    let groupStr=groupArray.join('*');
    const token = window.localStorage.getItem('token');
      window.location.href=baseUrl+'/reports/profitabilityDiagnosis/fullview/download?startdate='+moment(startDate).format('YYYY-MM-DD HH:mm')+"&enddate="+moment(endDate).format('YYYY-MM-DD HH:mm')+"&type=parent_sku&group="+groupStr+"&token="+token;
  }

  const FilterSet=() =>{
    console.log('Filter resete');
    console.log(group);
    if(group!=''){
      if(inArrayForString(group,groupArray)==false){ 
      setgroupArray(oldArray => [...oldArray,group] );
      setgroup('');
      }
    }
    console.log('Group')
    console.log(group);
    console.log(groupArray);
   
      //setProductCategoryStr();
    }
   
  

    const deleteGroupFn = (item,index) =>{
      console.log(item);
      removeItemOnce(groupArray,item);
      console.log(groupArray);
  
      let temp = groupArray.filter((category) => category !== item);
      console.log(temp);
      setgroupArray(temp);
    }
  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  
   
   
    return (
  
      <div id="wrapper" className>
        <Sidebar />
        <Header handleSignOut={handleSignOut} />



  <div></div> 
  <div></div>
  <div></div> 
  <div></div>
     
      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>
  
  
  
  
    
  
  
    <section id="content-wrapper">

    <label>Start Date</label>
    <label className='endDateStyle'>End Date</label>
    <label className='groupStyle'>Group</label>
  
    
    <div className="input-bar">
    <div className="input-bar-item width100">
    
    <DatePicker
     dateFormat="yyyy-MM-dd HH:mm"
     showTimeSelect
     timeFormat="p"
     timeIntervals={15}
      selected={startDate}
      className='width140x'
      onChange={(date) => setStartDate(date)}
      placeholder='Start Date'
      />

    </div>
    
    &nbsp;&nbsp;&nbsp;
 
    <div className="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd HH:mm"
      showTimeSelect
      timeFormat="p"
      timeIntervals={15}
      selected={endDate}
      className='width140x'
      onChange={(date) => setEndDate(date)}
      placeholder='End Date'
      />
      
    </div>
    &nbsp;&nbsp;&nbsp;

  
    <div className="input-bar-item width100">
    
    <input 
    type="text" 
     name='group'
     className='width140x'
     value={group}
     placeholder="Group"
     onChange={e => setgroup(e.target.value)} 
     
      />
      
    </div>
    &nbsp;&nbsp;&nbsp;

    
<div className="checkboxDiv">
<FormGroup>
  <FormControlLabel control={<Checkbox  
  sx={{ '& .MuiSvgIcon-root': { fontSize: 40 } }}
  name='Estimate Refunds/CBs'
  value={REFCB}
  defaultChecked={REFCB}
  onChange={() => setREFCB(!REFCB)}
  />} 
  label="Estimate Refunds/CBs" />
</FormGroup>
</div>

{!REFCB ?  '' :
    
      
    <div className="input-bar-item">
    
    <input 
    pattern="[0-9.]+" type="number"
     name='group'
     className='width62x'
     value={Refund}
     placeholder="Refunds"
     onChange={e => setRefund(e.target.value)} 
     
      />
      

    </div>
    }
    &nbsp;&nbsp;
   {!REFCB ?  '' :
    <div className="input-bar-item">
    
    <input 
    pattern="[0-9.]+" type="number"
     name='group'
     className='width92x'
     value={CB}
     placeholder="Chargebacks"
     onChange={e => setCB(e.target.value)} 
     
      />
    </div>
}


    <div className="input-bar-item">
    <button type="button"  onClick={FilterSet} className="btn btn-primary">Filter</button>
   
    </div>

    <div className="input-bar-item">
    <button type="button"  onClick={fetchApi} className="btn btn-primary">Run Report</button>
   
    </div>
    <div className='input-bar-item'>
    <button type="button"  onClick={ResetFilter} className="btn btn-primary">Reset</button>
    </div>

    {/* <div className='downloadReportBtn'>
        {
          
          reportData.length>0 ? <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>:''
         
        }
       
      </div> */}

<div className='downloadReportBtn'>
        {
          
          <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>
         
        }
       
      </div>
  </div>

  <div className="FilterSection">
  
  {groupArray.map((item, index) => (
      <span className="FilterSection"> 
       <span className='filterCategory' id={index}><span className="filterSpan">Group = {item}{ }</span>
       <span  onClick={(event) => deleteGroupFn(item,index)}><CloseIcon className='closeIcon'/></span>
       </span>
       <span className="whitespaceSpan">{ '            ' }</span>
       </span>
      
    ))}




    
  </div>
 

  {loader ?
  <div className='loaderDiv'>  
  <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" /></div> : 
  
  <MaterialTable
  // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
  onRowClick={((evt, selectedRow) => 
    setRowBackground(selectedRow)
    )}
  
  columns={[
    { title: "Group", field: "reportby",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    } 
  },
    { title: "Name.of.Group", field: "groupname",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
   },
    { 
      title: "Frontend", field: "front_end_count",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },
    { title: "Total.Orders", field: "total_orders",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },
    { title: "Total.Revenue", field: "revenue", 
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },
    { title: "Revenue.per.FE", field: "revenue_per_fe",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },
    { title: "Revenue.per.Order", field: "revenue_per_order",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },
    { title: "Number.of.Click.Bump", field: "click_bump_count",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "Click.Bump.Rate", field: "click_bump_rate",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "CPA", field: "CPA", 
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },
    { title: "Total.CPA.cost", field: "total_cpa_cost",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "COGS", field: "cogs", 
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },
    { title: "COGS.per.FE", field: "cogs_per_fe",
  
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },
    { 
      title: "Processing.Cost", field: "processing_cost",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },
    { title: "Reserves.Cost", field: "reserve_cost",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },
    { title: "Processing.plus.Reserves", field: "processing_plus_reserves",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "Total.Shipping.cost", field: "total_shipping_cost",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },

    { title: "Shipping.per.FE", field: "ship_cost_per_fe", 
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }

  },

    { title: "Total.Handling.Cost", field: "total_handling_cost",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },

    { title: "Handling.per.FE", field: "handling_cost_per_fe",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },

    { title: "Cost.of.CS", field: "cost_of_cs",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "CS.per.FE", field: "cost_of_cs_per_fe",
  
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },

    
    { title: "Total.Transaction.cost", field: "total_transactions_cost",
  
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "Transaction.cost.per.FE", field: "transactions_cost_per_fee",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },

    { title: "Number.of.Voids", field: "number_of_voids",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "Void.Rate.Percent", field: "void_rate_percent",
  
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },
    { title: "Void.Dollars.Amount", field: "void_dollar_amount",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "Void.Dollars.Percent", field: "void_dollar_percent",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },

    { title: "Number.of.Refunds", field: "number_of_refunds",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },

    { title: "Refund.Rate.Percent", field: "refund_rate_percent",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },

    { title: "Refund.Dollars.Amount	", field: "refund_dollar_amount",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }

  },
    { title: "Refund.Dollars.Percent", field: "refund_dollar_percent",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "Number.of.Chargebacks", field: "chargeback_count",
  
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },

    { title: "Chargebacks.Rate.Percent", field: "chargeback_rate_percent",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "Chargebacks.Dollars.Amount", field: "chargeback_dollar_amount",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "Chargebacks.Dollars.Percent", field: "chargeback_dollar_percent",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "Cashflow", field: "cashflow",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "Net.Profit", field: "net_profit",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
    { title: "Net.Profit.per.FE", field: "net_profit_per_fe",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  },
    { title: "Net.Profit.per.Order", field: "net_profit_per_order",
    cellStyle:(e,rowdata)=>{
      if(rowdata.last==1){
        return {fontWeight:'bold'}
      }
    }
  
  },
 
   
  ]}
  data={
      reportData
  }
   title={ReportTile}

  options={{
    // filtering:true,
    actionsColumnIndex: -1,
    addRowPosition: "first",
    pageSize:10,
    loadingType: 'overlay',
    paging: false,
    exportButton: true,
    maxBodyHeight: '500px',
    
    headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
    rowStyle: rowData => ({
      backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
    })
    }}
    // components={{
    //   OverlayLoading: props => (<div>Heye</div>)
    // }}
/>
        }
        </section>
       
      </div>

    )
}

function roundToTwo(num) {    
  return +(Math.round(num + "e+2")  + "e-2");
}

function inArrayForString(needle, haystack) {
  var length = haystack.length;
  for (var i = 0; i < length; i++) {
  if (haystack[i].toLowerCase() == needle.toLowerCase())
   return true;
  }
  return false;
 }

export default ByParentSKU
